import Axios from './axios'
import { HttpResponse } from '@/@types'
export class SpaceService {
  // eslint-disable-next-line require-await
  static async save(params: any) {
    return Axios('/user/ppt/save/', {
      method: 'post',
      responseType: 'json',
      data: {
        ...params
      },
    })
  }
  // eslint-disable-next-line require-await
  static async detail(id: string | number): Promise<HttpResponse> {
    return Axios('/user/ppt/detail-' + id, {
      method: 'post',
      responseType: 'json',
    })
  }  
  // eslint-disable-next-line require-await
  static async teamDetail(id: string | number): Promise<HttpResponse> {
    return Axios('/space/ppt/detail-' + id, {
      method: 'post',
      responseType: 'json'
    })
  }
  // eslint-disable-next-line require-await
  static async getUserTemplateList(params: any) {
    return Axios('/user/ppt/list/', {
      method: 'post',
      responseType: 'json',
      data: {
        ...params
      },
    })
  }
  
  // eslint-disable-next-line require-await
  static async getUserMaterialList(params: any) {
    return Axios('/user/material/list/', {
      method: 'post',
      responseType: 'json',
      data: {
        ...params
      },
    })
  }

  // 用户素材回收站
  // eslint-disable-next-line require-await
  static async getMaterialHistroyList(params: any) {
    return Axios('/user/material/histroy_list/', {
      method: 'get',
      params,
    })
  }  
  // 用户素材移入回收站
  // eslint-disable-next-line require-await
  static async hideMaterial(data: any) {
    return Axios('/user/material/hide/', {
      method: 'post',
      data,
    })
  }
  // 用户素材移入回收站
  // eslint-disable-next-line require-await
  static async delMaterial(data: any) {
    return Axios('/user/material/delete/', {
      method: 'post',
      data,
    })
  }
  // 用户素材恢复回收站
  // eslint-disable-next-line require-await
  static async showMaterial(data: any) {
    return Axios('/user/material/show/', {
      method: 'post',
      data,
    })
  }
  // 用户模板回收站
  // eslint-disable-next-line require-await
  static async getTemplateHistroyList(data: any) {
    return Axios('/user/ppt/histroy_list/', {
      method: 'get',
      data,
    })
  }  
  // 用户模板移入回收站
  // eslint-disable-next-line require-await
  static async hideTemplate(data: any) {
    return Axios('/user/ppt/hide/', {
      method: 'post',
      data,
    })
  }
  // 用户模板移入回收站
  // eslint-disable-next-line require-await
  static async delTemplate(data: any) {
    return Axios('/user/ppt/delete/', {
      method: 'post',
      data,
    })
  }
  // 用户模板移入回收站
  // eslint-disable-next-line require-await
  static async showTemplate(data: any) {
    return Axios('/user/ppt/show/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async templateDetail(id: string | number): Promise<HttpResponse> {
    return Axios('/ppt_template/detail-' + id, {
      method: 'post',
      responseType: 'json'
    })
  }

 
  // eslint-disable-next-line require-await
  static async folderList(data: any) {
    return Axios('/user/ppt_folder/list/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async addFolder(data: any) {
    return Axios('/user/ppt_folder/save/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async renameFolder(data: any) {
    return Axios('/user/ppt_folder/rename/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async deleteFolder(data: any) {
    return Axios('/user/ppt_folder/delete/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async moveFolder(data: any) {
    return Axios('/user/ppt_folder/move/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async movesFolder(data: any) {
    return Axios('/user/ppt_folder/moves/', {
      method: 'post',
      data,
    })
  }
  // 用户作品重命名
  // eslint-disable-next-line require-await
  static async renameTemplate(data: any) {
    return Axios('/user/ppt/rename', {
      method: 'post',
      data,
    })
  }
  // 作品克隆
  // eslint-disable-next-line require-await
  static async copyTemplate(data: any) {
    return Axios('/user/ppt/copy', {
      method: 'post',
      data,
    })
  }
  // 作品克隆
  // eslint-disable-next-line require-await
  static async pptTotal(data: any) {
    return Axios('/user/ppt/total/', {
      method: 'post',
      data,
    })
  }
  
}
